//@ts-nocheck
import React, { useEffect, useState } from "react";
import CheckboxField from "../../FieldTypes/CheckboxField/CheckboxField";
import NoteField from "../../FieldTypes/NoteField/NoteField";
import TableField from "../../FieldTypes/TableField/TableField";
import TextField from "../../FieldTypes/TextField/TextField";
import styles from "./TemplateManagerFieldAction.module.scss";
import { ExpandedContext } from "../../../utils/ExpandedContext";
import { getCurrentUser } from "aws-amplify/auth";
import OccupiedField from "../../FieldTypes/OccupiedField/OccupiedField";
import DropdownField from "../../FieldTypes/DropdownField/DropdownField";
import RadioField from "../../FieldTypes/RadioField/RadioField";
import Number from "../../FieldTypes/Number/Number";
import DateField from "../../FieldTypes/DateField/DateField";
import { useSingleton, useTheme } from "../../../hooks/useSingleton";
import ImageField from "../../FieldTypes/ImageField/ImageField";
import TemplateManagerTableField from "../FakeFieldTypes/TemplateManagerTableField/TemplateManagerTableField";
import ImageRollField from "../../FieldTypes/ImageRollField/ImageRollField";
import FieldMenu from "../../FieldMenu/FieldMenu";
import ReadOnlyText from "../../FieldTypes/ReadOnlyText/ReadOnlyText";
import PhoneField from "../../FieldTypes/PhoneField/PhoneField";
import TemplateManagerImageRollField from "../FakeFieldTypes/TemplateManagerImageRollField/TemplateManagerImageRollField";
import Section from "components/FieldTypes/Section/Section";

/**
 * The field action component to handle specific field recording actions
 * @param {object} fieldInstance the field fieldTemplate data combined with the instance.
 * @param {function} updateValue callback to update the linked fields hook
 */
function TemplateManagerFieldAction(props) {
	const { fieldInstance, fieldTemplate, fromTable, updateObj, online, userDoc } = props;
	const [fieldHtml, setFieldHtml] = useState(null);
	const [openFieldMenu, setOpenFieldMenu] = useState(false);

	const { mode } = useSingleton();

	function handleChange(data) {
		// just a fake handle change
	}

	function handleSubmit(data) {
		// a fake handleSubmit
	}

	function handleUpdate(data) {
		// fake handleUpdate
	}

	async function renderField() {
		const html = await handleTypes();
		setFieldHtml(html);
	}

	useEffect(() => {
		renderField();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fieldInstance, mode]);

	const color = useTheme();

	/**
	 * History handler.. fake
	 */
	function handleHistory(temp) {
		setOpenFieldMenu(!openFieldMenu);
	}

	function fakeCallback() {}

	async function handleTypes() {
		const user = await getCurrentUser();
		switch (fieldTemplate.inputType) {
			case "geospatial":
			case "geospatialutm":
			case "embeddedtext":
			case "readonlytext":
				return (
					<div className={fromTable ? styles.tableRow : styles.wrapperRow}>
						<ReadOnlyText color={color} fieldInstanceId={fieldInstance.id} fieldTemplate={fieldTemplate} fromTable={fromTable} />
					</div>
				);
			case "section":
				return (
					<div className={styles.wrapperRow}>
						<Section color={color} fieldInstanceId={fieldInstance.id} fieldTemplate={fieldTemplate} />
					</div>
				);
			case "phone":
				return (
					<div className={fromTable ? styles.tableRow : styles.wrapperRow}>
						<PhoneField
							username={fieldInstance.editing}
							authUsername={online ? user.username : userDoc.username}
							color={color}
							updateObj={updateObj}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							handleHistory={handleHistory}
							fieldInstanceId={fieldInstance.id}
							value={fieldInstance.value}
							handleChange={handleChange}
							handleFocus={fakeCallback}
							onBlur={handleSubmit}
							fromTable={fromTable}
							user={userDoc}
						/>
						<FieldMenu
							handleUpdate={fakeCallback}
							username={fieldInstance.editing}
							authUsername={userDoc.username}
							handleRevert={fakeCallback}
							online={online}
							removeUser={fakeCallback}
							openFieldMenu={openFieldMenu}
							fieldTemplate={fieldTemplate}
							userDoc={userDoc}
							currentFieldInstance={fieldInstance}
						/>
					</div>
				);
			case "date":
				return (
					<div className={styles.wrapperRow}>
						<DateField
							username={fieldInstance.editing}
							authUsername={online ? user.username : userDoc.username}
							color={color}
							handleHistory={handleHistory}
							updateObj={updateObj}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							value={fieldInstance.value}
							handleChange={handleChange}
							onBlur={handleSubmit}
							fromTable={fromTable}
							user={userDoc}
							moreHorizon={
								<FieldMenu
									handleUpdate={fakeCallback}
									username={fieldInstance.editing}
									authUsername={userDoc.username}
									handleRevert={fakeCallback}
									online={online}
									removeUser={fakeCallback}
									openFieldMenu={openFieldMenu}
									fieldTemplate={fieldTemplate}
									userDoc={userDoc}
									currentFieldInstance={fieldInstance}
								/>
							}
						/>
					</div>
				);
			case "number":
				return (
					<div className={fromTable ? styles.tableRow : styles.wrapperRow}>
						<Number
							username={fieldInstance.editing}
							authUsername={online ? user.username : userDoc.username}
							color={color}
							updateObj={updateObj}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							value={fieldInstance.value}
							handleChange={handleChange}
							handleHistory={handleHistory}
							onBlur={handleSubmit}
							fromTable={fromTable}
							user={userDoc}
							moreHorizon={
								<FieldMenu
									handleUpdate={fakeCallback}
									username={fieldInstance.editing}
									authUsername={userDoc.username}
									handleRevert={fakeCallback}
									online={online}
									removeUser={fakeCallback}
									openFieldMenu={openFieldMenu}
									fieldTemplate={fieldTemplate}
									userDoc={userDoc}
									currentFieldInstance={fieldInstance}
								/>
							}
						/>
					</div>
				);
			case "text":
			case "note":
				return (
					<div className={styles.wrapper}>
						<ExpandedContext.Consumer>
							{({ expandedField }) => (
								<NoteField
									username={fieldInstance.editing}
									authUsername={online ? user.username : userDoc.username}
									color={color}
									updateObj={updateObj}
									fieldInstance={fieldInstance}
									fieldTemplate={fieldTemplate}
									value={fieldInstance.value}
									handleChange={handleChange}
									handleHistory={handleHistory}
									onBlur={handleSubmit}
									fromTable={fromTable}
									user={userDoc}
									expandedField={expandedField}
									moreHorizon={
										<FieldMenu
											handleUpdate={fakeCallback}
											username={fieldInstance.editing}
											authUsername={userDoc.username}
											handleRevert={fakeCallback}
											online={online}
											removeUser={fakeCallback}
											openFieldMenu={openFieldMenu}
											fieldTemplate={fieldTemplate}
											userDoc={userDoc}
											currentFieldInstance={fieldInstance}
										/>
									}
								/>
							)}
						</ExpandedContext.Consumer>
					</div>
				);
			case "checkbox":
				return (
					<div className={styles.wrapper}>
						<CheckboxField
							fromTable={fromTable}
							color={color}
							updateObj={updateObj}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							value={fieldInstance.value}
							handleChange={handleChange}
							handleHistory={handleHistory}
							handleSubmit={handleSubmit}
							user={userDoc}
						/>
						<FieldMenu
							handleUpdate={fakeCallback}
							username={fieldInstance.editing}
							authUsername={userDoc.username}
							handleRevert={fakeCallback}
							online={online}
							removeUser={fakeCallback}
							openFieldMenu={openFieldMenu}
							fieldTemplate={fieldTemplate}
							userDoc={userDoc}
							currentFieldInstance={fieldInstance}
						/>
					</div>
				);
			case "radio":
				return (
					<div className={styles.wrapper}>
						<RadioField
							color={color}
							updateObj={updateObj}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							value={fieldInstance.value}
							handleChange={handleChange}
							handleHistory={handleHistory}
							handleSubmit={handleSubmit}
							user={userDoc}
							fromTable={fromTable}
						/>
						<FieldMenu
							handleUpdate={fakeCallback}
							username={fieldInstance.editing}
							authUsername={userDoc.username}
							handleRevert={fakeCallback}
							online={online}
							removeUser={fakeCallback}
							openFieldMenu={openFieldMenu}
							fieldTemplate={fieldTemplate}
							userDoc={userDoc}
							currentFieldInstance={fieldInstance}
						/>
					</div>
				);
			case "table":
				return (
					<div className={styles.wrapper}>
						<TemplateManagerTableField
							color={color}
							updateObj={updateObj}
							initialFieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							value={fieldInstance.value}
							handleChange={handleChange}
							handleSubmit={handleSubmit}
							online={online}
							userDoc={userDoc}
						/>
					</div>
				);
			case "dropdown":
				// console.log('its a dropdown faker: ', fieldTemplate);
				return (
					<div className={styles.wrapper}>
						<DropdownField
							color={color}
							updateObj={updateObj}
							fromTable={fromTable}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							value={fieldInstance.value}
							handleChange={handleChange}
							handleHistory={handleHistory}
							handleSubmit={handleSubmit}
							online={online}
							user={userDoc}
							moreHorizon={
								<FieldMenu
									handleUpdate={fakeCallback}
									username={fieldInstance.editing}
									authUsername={userDoc.username}
									handleRevert={fakeCallback}
									online={online}
									removeUser={fakeCallback}
									openFieldMenu={openFieldMenu}
									fieldTemplate={fieldTemplate}
									userDoc={userDoc}
									currentFieldInstance={fieldInstance}
								/>
							}
						/>
					</div>
				);
			case "image":
				return (
					<div className={styles.wrapperRow}>
						<ImageField
							userDoc={userDoc}
							fieldInstance={fieldInstance}
							fieldTemplate={fieldTemplate}
							handleChangeCb={handleChange}
							handleSubmitCb={handleSubmit}
							online={online}
							setupChanged={fakeCallback}
							user={userDoc}
						/>
					</div>
				);
			case "imageroll":
				return (
					<div className={styles.wrapperRow}>
						<TemplateManagerImageRollField
							formGroupType={"default"}
							projectId={"FAKE"}
							updateObj={updateObj}
							userDoc={userDoc}
							fieldTemplate={fieldTemplate}
							online={online}
							color={color}
							initialFieldInstance={fieldInstance}
							handleChange={handleChange}
							handleSubmit={handleSubmit}
						/>
					</div>
				);
			default:
				return null;
		}
	}
	return fieldHtml;
}

export default TemplateManagerFieldAction;
